import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import {
  API_GET_NOTIFICATIONS,
  API_UPDATE_NOTIFICATION,
} from "../../api/notification.service";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  // Fetch Notifications
  const fetchNotifications = async () => {
    try {
      const data = await API_GET_NOTIFICATIONS();
      setNotifications(data.rows);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // Handle Toggle Notification Status
  const toggleNotification = async (notification) => {
    try {
      await API_UPDATE_NOTIFICATION(notification.id, {
        isEnabled: !notification.isEnabled,
      });
      setNotifications((prev) =>
        prev.map((notif) =>
          notif.id === notification.id
            ? { ...notif, isEnabled: notif.isEnabled ? false : true }
            : notif
        )
      );
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
  };

  // Handle Delete Notification
  const deleteNotification = async (notification) => {
    try {
      await API_UPDATE_NOTIFICATION(notification.id, {
        isActive: false,
      });
      setNotifications((prev) =>
        prev.filter((notif) => notif.id != notification.id)
      );
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  // Edit Notification
  const editNotification = (notification) => {
    setSelectedNotification(notification);
    setDialogVisible(true);
  };

  return (
    <div className="p-4">
      <h2>Notification Manager</h2>

      <DataTable value={notifications} paginator rows={5} stripedRows>
        <Column field="companyId" header="ID" sortable></Column>
        <Column field="message" header="Message"></Column>
        <Column field="type" header="Type"></Column>
        <Column
          field="isEnabled"
          header="Enabled"
          body={(rowData) => (
            <InputSwitch
              checked={rowData.isEnabled}
              className="custom-switch"
              onChange={() => toggleNotification(rowData)}
            />
          )}
        ></Column>
        <Column
          body={(rowData) => (
            <>
              <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-info"
                onClick={() => editNotification(rowData)}
              />
              <Button
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger ml-2"
                onClick={() => deleteNotification(rowData)}
              />
            </>
          )}
          header="Actions"
        ></Column>
      </DataTable>

      {/* Dialog for Editing */}
      <Dialog
        visible={dialogVisible}
        header="Edit Notification"
        onHide={() => setDialogVisible(false)}
        modal
        style={{ width: "30vw" }}
      >
        <div className="p-fluid">
          <div className="p-field">
            <label>Message</label>
            <InputText
              value={selectedNotification?.message || ""}
              onChange={(e) =>
                setSelectedNotification({
                  ...selectedNotification,
                  message: e.target.value,
                })
              }
            />
          </div>
          <div className="p-field">
            <label>Type</label>
            <Dropdown
              value={selectedNotification?.type || "info"}
              options={[
                { label: "Info", value: "info" },
                { label: "Warning", value: "warning" },
                { label: "Success", value: "success" },
                { label: "Error", value: "error" },
                { label: "Secondary", value: "secondary" },
                { label: "Contrast", value: "contrast" },
              ]}
              onChange={(e) =>
                setSelectedNotification((prev) => ({
                  ...prev,
                  type: e.value,
                }))
              }
            />
          </div>
          <div className="p-field">
            <Checkbox
              inputId="isEnabled"
              checked={selectedNotification?.isEnabled || false}
              onChange={(e) =>
                setSelectedNotification({
                  ...selectedNotification,
                  isEnabled: e.checked,
                })
              }
            />
            <label htmlFor="isEnabled">Enabled</label>
          </div>
        </div>
        <div className="p-dialog-footer">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setDialogVisible(false)}
          />
          <Button
            label="Update"
            icon="pi pi-check"
            className="p-button-primary"
            onClick={async () => {
              if (selectedNotification) {
                try {
                  await API_UPDATE_NOTIFICATION(
                    selectedNotification.id,
                    selectedNotification
                  );
                  setNotifications((prev) =>
                    prev.map((notif) =>
                      notif.id === selectedNotification.id
                        ? selectedNotification
                        : notif
                    )
                  );
                  setDialogVisible(false);
                } catch (error) {
                  console.error("Error updating notification:", error);
                }
              }
            }}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default Notifications;
